import { Box, Flex, Grid, GridItem, keyframes, Link, styled, theme } from '@nilohealth/core-ui'
import * as Dropdown from '@radix-ui/react-dropdown-menu'

export const DashboardsTrigger = styled(Dropdown.Trigger, {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: 0,
  backgroundColor: 'transparent',
  borderRadius: '$small',
  outline: 'none',
  width: 'fit-content',
  height: '$xxsmall',
  '&:hover': {
    cursor: 'pointer',
    backgroundColor: '$neutralHighLight',
  },
  '&:focus, &:active': {
    outline: 0,
    boxShadow: '0 0 0 $borderWidths$thick $colors$primaryMedium',
  },
  variants: {
    active: {
      true: {
        cursor: 'pointer',
        backgroundColor: '$primaryLight',
        outline: 0,
      },
    },
  },
})

const scaleIn = keyframes({
  from: { height: 0 },
  to: { height: 'fit-content' },
})

export const DashboardsContent = styled(Dropdown.Content, {
  position: 'relative',
  width: '100vw',
  minHeight: '300px',
  height: 'fit-content',
  maxHeight: 'calc(100vh - $large)',
  paddingBottom: '$xxsmall',
  backgroundColor: '$neutralHighPure',
  zIndex: '$dialog',
  animation: `${scaleIn} 1.5s height ease-in`,
})

export const DashboardsCategoryList = styled(GridItem, {
  paddingTop: '$xxsmall',
  display: 'flex',
  flexDirection: 'column',
  rowGap: '$nano',
  gridRow: 1,
  width: '100%',
  '@sm': { gridColumn: '1 / span 2' },
  '@md': { gridColumn: '1 / span 5' },
  '@lg': { gridColumn: '1 / span 5' },
})

export const DashboardsIndicatorList = styled(GridItem, {
  paddingTop: '$xxsmall',
  display: 'flex',
  flexDirection: 'column',
  rowGap: '$nano',
  gridRow: 1,
  width: '100%',
  '@sm': { gridColumn: '3 / span 2' },
  '@md': { gridColumn: '7 / span 5' },
  '@lg': { gridColumn: '7 / span 5' },
})

export const DashboardCategoryLink = styled(Link, {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  columnGap: '$quarck',
  width: 'fit-content',
  color: '$neutralLowDark',
  border: 'none !important',
})

export const DashboardsCategoryContainer = styled(Grid, {
  width: '100%',
  height: 'calc($xxlarge - $quarck)',
  paddingTop: '$xxxsmall',
  paddingBottom: '$xxxsmall',
  '&:hover': {
    cursor: 'pointer',
    [`${DashboardCategoryLink}`]: {
      color: '$primaryMedium !important',
      textDecoration: 'underline',
    },
  },
})

export const DashboardCategoryIcon = styled(Box, {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '$xxsmall',
  height: '$xxsmall',
  borderRadius: '$circular',
  backgroundColor: `${theme.colors.primaryMedium.value}${theme.opacitiesHex.light.value}`,
  svg: {
    width: '$xxxsmall',
    height: '$xxxsmall',
    color: '$primaryMedium',
  },
})

export const DashboardCategoryMarker = styled(Flex, {
  border: '1px solid $neutralLowDark',
  width: '2px',
  height: 'calc($small + $quarck)',
})

export const DashboardIndicatorContent = styled(Flex, {
  width: '100%',
  columnCount: 3,
  columnGap: '$xxxsmall',
})

export const DashboardTextLink = styled(Link, {
  color: '$neutralLowDark',
  fontSize: '$xsmall',
  lineHeight: '$lineHeight116',
  fontWeight: '$medium',
  height: 'calc($xxxsmall + $quarck)',
  width: 'fit-content',
  '&:hover': {
    color: '$primaryMedium',
    borderBottom: 'none',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
})
